import React from 'react';
import withProps from "recompose/withProps";
import { shiftOfObject } from "@gqlapp/base/utils/filterObject";
import toPath from 'element-to-path';

export function getStyle($options: any[], style:string){
	return shiftOfObject($options, function ($value: any, $key: string){
		return !!$value && [`${style}`, 'default'].includes($key);
	});
}

export function getTextPath(data: any){
	return toPath(data);
}

export function Svg({ children, fontPath, ...props}: any){
	return (<svg {...props}>
		{(!!fontPath) && <defs>
			<style
				type="text/css"
				dangerouslySetInnerHTML={{ __html: `@import url('${fontPath}')`}}
			/>
		</defs>}
		{children}
	</svg>);
}


/**
 *
 * @param typeCallback
 * @param callback
 * @param options
 */
export default function optionCallback(typeCallback: string, callback: any, options?: any) {
	let path: string;
	if (options?.toPath) {
		path = toPath(options?.toPath);
	}
	return withProps((props: any) => {
		let frames = props?.frames || {}
		
		frames[typeCallback] = Object.assign(
			{name: typeCallback},
			{callback: (v: any) => callback({...v, Svg, path}), options: options || {}}
		)
		return {frames}
	});
}